<template>
    <div>
		<tab name="3"></tab>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/daping/invite/update')" type="primary" icon="el-icon-plus" size="small"
                @click="$refs.viteadd.show()">新建</el-button>
        </div>
        <div class="page-list-box">			
			<div class="MT10">面板访问地址:
				<el-link
					type="primary"
					size="small"
					:href="`${ssfb}/viteData`"
					target="_blank"
					>{{ssfb}}/viteData</el-link>
			</div>			
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe class="MT20">
				<el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="title" label="演出标题" show-overflow-tooltip min-width="150"></el-table-column>
				<el-table-column prop="sessionId" label="场次ID"></el-table-column>
				<el-table-column prop="sessionName" label="场次名称" show-overflow-tooltip min-width="150"></el-table-column>                
				<el-table-column prop="addTime" label="添加时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="120">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/daping/invite/update')" type="text" size="small" icon="el-icon-edit" @click="$refs.viteadd.show(scope.row)">编辑
                        </el-button>
						
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <vite-add ref="viteadd" @onUpdate="getDataList"></vite-add>
    </div>
</template>
<script>
import ViteAdd from "./components/viteadd.vue";
import Tab from './components/tab'
const defaultParams = {
    pageNo: 1,
}
export default {
    components: { ViteAdd,Tab },

    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])
            },
            listLoading: true,
			ssfb:process.env.VUE_APP_SSFB_URL
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/daping/invite/list",
                method: "POST",
                params: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },		
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        }
    }
}
</script>

<style lang="scss" scoped>
</style>